export const Operation = Object.freeze({
  FETCH: "source.fetch",
  FORMAT_READ: "format.read"
});

export const Message = Object.freeze({
  CANCEL: "cancel",
  EXECUTE: "execute",
  RESULT: "result"
});
